import React, { createContext } from 'react';

export const ContactoContext = createContext();